export default __webpack_public_path__ + "static/media/basic-icon.fcff9c41.svg";